import About from '@/app/views/About.vue';
import CookiesPolicy from '@/app/views/CookiesPolicy.vue';
import Glosowanie from '@/app/views/Glosowanie.vue';
import Home from '@/app/views/Home.vue';
import Oplaty from '@/app/views/Oplaty.vue';
import Regulamin from '@/app/views/Regulamin.vue';
import Walne from '@/app/views/Walne.vue';
import Walne2019 from '@/app/views/Walne2019.vue';
import Walne2026 from '@/app/views/Walne2026.vue';
import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/komitet',
    name: 'about',
    component: About,
  },
  {
    path: '/regulamin',
    name: 'regulamin',
    component: Regulamin,
  },
  {
    path: '/oplaty',
    name: 'oplaty',
    component: Oplaty,
  },
  {
    path: '/glosowanie',
    name: 'glosowanie-lista',
    component: Glosowanie,
    children: [
      {
        path: ':id',
        name: 'glosowanie',
        component: Glosowanie,
      },
    ],
  },
  {
    path: '/polityka-cookies',
    name: 'cookies-policy',
    component: CookiesPolicy,
  },
  {
    path: '/walne',
    name: 'walne',
    component: Walne,
  },
  {
    path: '/walne/2019',
    name: 'walne-2019',
    component: Walne2019,
  },
  {
    path: '/walne/2026',
    name: 'walne-2026',
    component: Walne2026,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
